var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('Main'),_c('audio',{ref:"bgm",attrs:{"src":_vm.musicSrc,"loop":"","preload":"auto"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }